/** Modern Lucide-style SVG icon keys (see sidebar-icons.registry). */
export const GP_SECTION_ICONS = {
  profile: "building",
  address: "map-pin",
  courier: "truck",
  time: "clock",
  brand: "sparkles",
  social: "share-2",
  whatsapp: "whatsapp",
  catalog: "book-open",
  subscription: "meta",
  dayOffs: "calendar",
  email: "mail",
  vitrine: "store",
} as const;
